export default {
  PUT_CANCEL_DOSSIER: 'PUT_CANCEL_DOSSIER'
}
